import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "result-table" }
const _hoisted_2 = {
  key: 0,
  class: "result-table__message"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "result-table__list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "result-table__message"
}
const _hoisted_8 = { class: "result-table__bottom" }
const _hoisted_9 = { class: "result-table__displayed-results" }
const _hoisted_10 = {
  key: 2,
  class: "result-table__message"
}

import { watch, computed } from 'vue';
import { columnConfig, IColumnItem, initialVisibility } from '@/interfaces/search/IQueryColumn';
import { useFilterStore } from "@/stores/filterStore";
import { useFilterApply } from '@/services/filter-apply-service';
import { useSearch } from '@/services/search-service';
import { useStore } from "@/stores/store";

import Pagination from '@/components/pagination/Pagination.vue';
import SearchResult from '@/components/searchresult/SearchResult.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'ResultTable',
  setup(__props) {

const filterStore = useFilterStore();
const { applyFilters } = useFilterApply();
const { sortSearchResult } = useSearch();
const store = useStore();

const noVisibleColumns = computed(() => {
    return Object.values(columnConfig).every((config: IColumnItem) => !config.visible);
});

watch([() => store.mapVersion, () => filterStore.filterPanelOpen], ([newMapVersion, newFilterPanelOpen], [oldMapVersion, oldFilterPanelOpen]) => {
    if (newMapVersion === false || newFilterPanelOpen !== oldFilterPanelOpen) {
        adjustTableColumns();
    }
});

const sortData = (key: string) => {
    if (store.sorting.dataKey != key) {
        store.sorting.descending = true;
        store.sorting.dataKey = key;
        sortSearchResult(key, store.sorting.descending);
    }

    else if (store.sorting.dataKey == key && store.sorting.descending == true) {
        store.sorting.descending = false;
        sortSearchResult(key, store.sorting.descending);
    }

    else {
        store.sorting.descending = true;
        store.sorting.dataKey = null;
        store.searchResult = store.originalSearchResult;
        applyFilters();
    }

    store.currentPage = 0;
};

function adjustTableColumns() {
  const element = document.getElementById('container');
  if (!element) return;

  let availableWidth = element.offsetWidth - (filterStore.filterPanelOpen ? 400 : 0);
  const maxColumnWidth = 300;
  let maxColumns = Math.floor(availableWidth / maxColumnWidth);

  const visibleColumns = Object.entries(columnConfig)
    .filter(([key, cfg]) => cfg.visible)
    .sort((a, b) => a[1].priority - b[1].priority);

  const autoColumns = Object.entries(columnConfig)
    .filter(([key]) => initialVisibility[key]) // only those that were initially true
    .sort((a, b) => a[1].priority - b[1].priority);

  if (visibleColumns.length > maxColumns) {
    // hide all auto columns
    autoColumns.forEach(([key]) => {
      columnConfig[key].visible = false;
    });

    // show the highest-priority ones, but only from initial true set
    autoColumns.slice(0, maxColumns).forEach(([key]) => {
      columnConfig[key].visible = true;
    });
  } else {
    // make sure all initial-true columns that fit are visible
    autoColumns.forEach(([key], index) => {
      columnConfig[key].visible = index < maxColumns;
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).apiErrorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(store).apiErrorMessage), 1 /* TEXT */))
      : (_unref(store).searchResult?.results != null && _unref(store).searchResult.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(store).searchResult?.results != null && _unref(store).searchResult.results.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnConfig), (config, dataKey) => {
                          return (_openBlock(), _createElementBlock("th", {
                            class: _normalizeClass(["column", { 'result-table__column--hidden': !config.visible }]),
                            key: dataKey
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", {
                                onClick: ($event: any) => (sortData(dataKey))
                              }, _toDisplayString(config.displayName), 9 /* TEXT, PROPS */, _hoisted_5),
                              (dataKey === _unref(store).sorting.dataKey)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(!_unref(store).sorting.descending ?
                                        '↑' : '↓'), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).displayedResults, (hit) => {
                        return (_openBlock(), _createBlock(SearchResult, {
                          key: hit.id,
                          result: hit,
                          columnConfig: _unref(columnConfig)
                        }, null, 8 /* PROPS */, ["result", "columnConfig"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (noVisibleColumns.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Du måste välja minst en kolumn för att visa sökresultat. "))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(_unref(store).displayedResults.length), 1 /* TEXT */),
                _createTextVNode(" av " + _toDisplayString(_unref(store).searchResult?.results.length) + " träffar ", 1 /* TEXT */)
              ]),
              _createVNode(Pagination)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Inget resultat hittades "))
  ]))
}
}

})